/** Normalize Ethereum wallet addresses for account lookup. */
export const normalizeWalletAddress = (address: string): string => address.toLowerCase();
